import { httpGet, httpPost } from "../Web";
import { ApiResponse } from "./ApiResponse";

export interface WorkshopProductProperty {
    workshopProductId: number,
    interfacePropertyId: number,
    testCombinationId: number,
    value: string,
    guid?: string,
    id?: number,
    jsonError?: boolean
}

export const deleteWorkshopProductProperty = async (propertyId: number, abortController: AbortController) => {
    return httpGet(`/api/workshopproduct/property/delete/${propertyId}`, new AbortController())
}

export const deleteWorkshopProductProperties = async(propertyIds: number[]) => {
    return Promise.all(propertyIds.map(pId => deleteWorkshopProductProperty(pId, new AbortController())));
}

export const getWorkshopProductProperties = async(workshopProductId: number, abortController: AbortController): Promise<ApiResponse<WorkshopProductProperty[]>> => {
    return httpGet(`/api/workshopproduct/property/${workshopProductId}`, abortController);
}

export const updateWorkshopproductProperty = async(workshopProductProperty: WorkshopProductProperty) => {
    return httpPost('/api/workshopproduct/property/update', workshopProductProperty, new AbortController())
}

export const updateWorkshopProductProperties = async(workshopProductProperties: WorkshopProductProperty[]) => {
    return Promise.all(workshopProductProperties.map(wpp => updateWorkshopproductProperty(wpp)));
}